import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import ReviewStars from "../../../elements/ReviewStars";
import ImageUser01 from "../../../../assets/image/image-user-01.webp";
import Image from "../../../elements/Image";
import { testimonialsList } from "../../../../services/testimonialsService";
import useFetch from "../../../../hooks/useFetch";
import { initialsValue, removeTag } from "../../../../helpers";
import Indentification from "../../../elements/Indentification";
import { useBanner } from "../../../../providers/BannerProviders";

const TestimonialSection = () => {
  useEffect(() => {
    setTimeout(() => {
      document
        .querySelector(".swiper-button-next")
        ?.classList.remove("swiper-button-disabled");
      document
        .querySelector(".swiper-button-prev")
        ?.classList.remove("swiper-button-disabled");
    }, 500);
  }, []);

  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.bannerType === "home");

  const {
    data: testimonialData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-testimonials"],
    fetchFunction: async () => {
      const res = await testimonialsList({
        limit: 30,
      });
      if (res?.docs?.status === 200) {
        return res?.docs?.data?.map((item) => ({
          _id: item?._id,
          review: item?.rating * 20 || 0,
          description: item?.comments,
          user: item?.image?.url,
          name: item?.name,
          location: item?.address,
        }));
      } else {
        return [];
      }
    },
  });

  return (
    <section className="relative flex w-full py-16 sm:py-24 bg-blue-zodiac">
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <div className="space-y-10 sm:space-y-16">
          <div className="relative text-white text-center space-y-2">
            <h2
              className="text-3xl sm:text-4xl xls:text-[42px] font-bold"
              dangerouslySetInnerHTML={{
                __html: homeBanner?.details?.testimonial?.title,
              }}
            />
            <h3
              className="text-base xls:text-lg xls:font-medium font-Gotham"
              dangerouslySetInnerHTML={{
                __html: homeBanner?.details?.testimonial?.description,
              }}
            />
          </div>
          <div className="relative space-y-6">
            <Swiper
              loop={testimonialData?.length >= 3}
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 10 },
                768: { slidesPerView: 2, spaceBetween: 16 },
                990: { slidesPerView: 3, spaceBetween: 16 },
                1025: { slidesPerView: 3, spaceBetween: 30 },
              }}
              freeMode={true}
              navigation={{
                nextEl: ".testimonial-swiper-button-next",
                prevEl: ".testimonial-swiper-button-prev",
              }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              observer={true}
              observeParents={true}
              modules={[Navigation, Autoplay]}
            >
              {testimonialData?.map((item) => (
                <SwiperSlide key={item?._id} className="!h-auto !flex">
                  <div className="relative bg-white py-6 px-6 space-y-5 w-full flex flex-col">
                    <div className="relative space-y-4 mb-5">
                      {/* <ReviewStars rating={item?.review} /> */}
                      <div
                        className="text-sm xls:text-base xl:text-lg font-medium"
                        dangerouslySetInnerHTML={{
                          __html: item?.description,
                        }}
                      />
                    </div>
                    <div className="flex items-center gap-3 !mt-auto">
                      <div className="w-14 aspect-square overflow-hidden rounded-full flex-shrink-0">
                        <Indentification
                          image={item?.user}
                          alt={item?.name}
                          initial={initialsValue(item?.name)}
                        />
                      </div>
                      <div className="space-y-1 flex-shrink flex-grow">
                        <div
                          className="text-sm xls:text-base xl:text-lg font-medium"
                          dangerouslySetInnerHTML={{
                            __html: item?.name,
                          }}
                        />
                        <div
                          className="text-[10px] xls:text-xs xl:text-sm font-medium font-Gotham text-shades-06"
                          dangerouslySetInnerHTML={{
                            __html: item?.location,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="relative flex items-center justify-center gap-4">
              <div className="testimonial-swiper-button-prev relative w-9 h-9 bg-transparent border-[3px] border-white text-white shadow-lg flex items-center justify-center rounded-full cursor-pointer text-lg">
                <i className="fa-regular fa-arrow-left"></i>
              </div>
              <div className="testimonial-swiper-button-next relative w-9 h-9 bg-transparent border-[3px] border-white text-white shadow-lg flex items-center justify-center rounded-full cursor-pointer text-lg">
                <i className="fa-regular fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
